import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from './toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class InterceptorNotificationService {
  constMessageRoutes = ["togglenotificationsubscribtion"];

  constructor(private translate: TranslateService,
    private toastService: ToastService) {
  }

  handleErrorMessage(message: string) {
    this.toastService.error(message);
  }

  handleSuccess(success: HttpErrorResponse) {
    const messageKey = this.constMessageRoutes.some(str => success.url?.toLowerCase().includes(str)) ? 'messages.entitySaveSuccessfully' : '';

	if(!messageKey) {
		return;
	}

    this.translate
      .get(messageKey, { entity: "", name: "" })
      .subscribe((res: string) => {
        this.toastService.success(res);
      });
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}